import type { Locale } from '@/config/build/index.js';

import { noaIntegrationConfigTransformer } from '../definitions/noa-integration/config';
import { ssoConfigTransformer } from '../definitions/sso/config';
import type { Environment, GlobalConfig } from '../types';
import { ENV, REQUEST } from '../types';

export interface ConfigDefinition {
  productionUrls: Map<Locale, string>;
  developmentUrls: Map<Locale, string>;
  testingUrl: (testingName: string) => string;
}

export const useRequestUrl =
  ({ productionUrls, developmentUrls, testingUrl }: ConfigDefinition) =>
  ({
    locale,
    env,
    testingName,
    baseURL,
  }: {
    locale: Locale;
    env: Environment;
    testingName?: string;
    baseURL?: string;
  }) => {
    if (baseURL) {
      return baseURL;
    }

    if (env === ENV.testing && testingName) {
      return testingUrl(testingName);
    }

    const urls = env === ENV.production ? productionUrls : developmentUrls;

    return urls.get(locale);
  };

export const useConfigTransformer = <E>(requestType: REQUEST) => {
  const transformersMap = {
    [REQUEST.BASE]: (config: GlobalConfig) => config,
    [REQUEST.SSO]: ssoConfigTransformer<E>,
    [REQUEST.NOA_INTEGRATIONS]: noaIntegrationConfigTransformer<E>,
  };

  return transformersMap[requestType] as (config: GlobalConfig) => E;
};
